import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCustomerById } from '../../Customers/apiService';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { useCheckoutContext } from '../../../contexts/Checkout';

import { useUrlParams } from '../../../contexts/UrlParams';

import { getTicketsByAppointment, getTicketById } from '../../Service_Tickets/apiService';

const CustomerInfo = () => {
  const { values, setFieldValue } = useFormikContext() || {};
  const { formValues, setFormValues } = useFormData() || {};

  const { url_params, setUrlParams } = useUrlParams();

  const { appointment, service } = useCheckoutContext() || {};

  let st = appointment || service || {}

  useEffect(() => {
    if (values?.invoice_id) {
      setUrlParams(`checkout/complete/${values?.invoice_id}`);
    }
  }, [values?.invoice_id]);

  const { data: services } = useQuery({
    queryKey: ['service_tickets', appointment?.appointment_id],
    queryFn: () => getTicketsByAppointment(appointment?.appointment_id),
    enabled: !!appointment?.appointment_id,
    staleTime: Infinity
  });

  const { data: service_ticket } = useQuery({
    queryKey: ['service_ticket', st?.service_ticket_id],
    queryFn: () => getTicketById(st?.service_ticket_id),
    enabled: !!st?.service_ticket_id,
    staleTime: Infinity
  })


  const { data: customer } = useQuery({
    queryKey: ['customer', st?.customer_id, st?.appointment_id, values?.invoice_id],
    queryFn: () => getCustomerById(st?.customer_id),
    enabled: !!st?.customer_id,
    staleTime: Infinity
  });

  useEffect(() => {
    if (customer) {
      setFormValues(ofv => ({ ...ofv, customer, client_name: customer.full_name }));
    }
  }, [customer]);

  // useEffect(() => {
  //   console.log(customer, "customer", values?.total, customer?.final_balance - (values?.total || 0));
  //   if (customer?.final_balance - (values?.total || 0) >= 0) {
  //     setFieldValue('apply_credit', false);
  //   } else {
  //     if (values?.balance > 0) {
  //       setFieldValue('apply_credit', true);
  //     }
  //   }
  // }, [customer, values?.total, values?.balance]);

 useEffect(() => {
    // Invoice already loaded — its line items drive `services`, don't overwrite.
    if (values?.invoice_id) return;

    // Only use the appointment (plural) source when an appointment is actually
    // in play. Guarding on `services?.length` alone let stale/cached appointment
    // tickets leak into pickup checkouts that have no appointment.
    if (appointment?.appointment_id && services?.length) {
      let service_tickets = services.map((el, i) => {
        return {
          service_ticket_id: el.service_ticket_id,
          name: el.service_name,
          rate: el.total,
          duration: el.duration_in_minutes,
          quantity: 1,
          stylist: el.stylist,
          stylist_id: el.stylist_id,
          wig_id: el.wig_id,
          service_date: el.scheduled_date,
          service_ticket_num: el.service_ticket_num,
          description: el.description || `Service on wig #${el.wig_id}`
        }
      })
      setFieldValue('services', service_tickets);
    } else if (service_ticket) {
      setFieldValue('services', [{
        service_ticket_id: service_ticket.service_ticket_id,
        name: service_ticket.service_name,
        rate: service_ticket.total,
        duration: service_ticket.duration_in_minutes,
        quantity: 1,
        stylist: service_ticket.stylist,
        stylist_id: service_ticket.stylist_id,
        wig_id: service_ticket.wig_id,
        service_date: service_ticket.scheduled_date,
        service_ticket_num: service_ticket.service_ticket_num,
        description: service_ticket.description || `Service on wig #${service_ticket.wig_id}`
      }])
    }
  }, [appointment?.appointment_id, services, service_ticket, values?.invoice_id])

  useEffect(() => {
    if (appointment?.appointment_id) {
      setFieldValue('appointment_id', appointment?.appointment_id);
    }
  }, [appointment?.appointment_id]);

  useEffect(() => {
    if (st?.customer_id) {
      setFieldValue('customer_id', st?.customer_id);
    }
  }, [st?.customer_id]);

  return null;
};

export default CustomerInfo;